import { render, staticRenderFns } from "./DeliveryDetailParcelLogs.vue?vue&type=template&id=355935b5&scoped=true&"
import script from "./DeliveryDetailParcelLogs.vue?vue&type=script&lang=js&"
export * from "./DeliveryDetailParcelLogs.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryDetailParcelLogs.vue?vue&type=style&index=0&id=355935b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355935b5",
  null
  
)

export default component.exports